import * as api from '@/api/gallery'
import Gallery from '@/store/models/gallery'
import GalleryImage from '@/store/models/galleryImage'

export let state = {
  gallery: new Gallery,
  galleries: {
    data: []
  },
  image: new GalleryImage,
  galleryList: []
}

export let mutations = {
  setGalleries: (state, payload) => state.galleries = payload,
  setGalleryList: (state, payload) => state.galleryList = payload,

  setGallery: (state, payload) => state.gallery = (new Gallery).hydrate(payload),
  reset: state => state.gallery = new Gallery,
  setTitle: (state, payload) => state.gallery.title = payload,
  setActive: (state, payload) => state.gallery.active = payload,

  setGalleryImage: (state, payload) => state.image = (new GalleryImage).hydrate(payload),
  resetGalleryImage: state => state.image = new GalleryImage,
  setCaption: (state, payload) => state.image.caption = payload,
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setGalleries', response.data)
      resolve()
    }, reject)
  }),
  
  load: ({ commit }, gallery) => new Promise((resolve, reject) => {
    api.load(gallery, response => {
      commit('setGallery', response.data)
      resolve()
    }, reject)
  }),

  list: ({ commit }) => new Promise((resolve, reject) => {
    api.list(response => {
      commit('setGalleryList', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }) => new Promise((resolve, reject) => {
    api.create(state.gallery, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.gallery, () => {
      commit('reset')
      resolve()
    }, reject)
  }),
  
  remove: ({ }, gallery) => new Promise((resolve, reject) => {
    api.remove(gallery.id, resolve, reject)
  }),
  
  removeFile: ({ }, image) => new Promise((resolve, reject) => {
    api.removeFile(image.id, resolve, reject)
  }),
  
  loadGalleryImage: ({ commit }, imageId) => new Promise((resolve, reject) => {
    api.loadGalleryImage(imageId, response => {
      commit('setGalleryImage', response.data)
      resolve()
    }, reject)
  }),
  
  updateGalleryImage: ({ state, commit }) => new Promise((resolve, reject) => {
    api.updateGalleryImage(state.image, () => {
      commit('resetGalleryImage')
      resolve()
    }, reject)
  }),
}